import { BaseEntity } from "yt-ng-framework";

export class KomitentEmail extends BaseEntity{
    constructor(){
        super();
    }

    KomitentID: number = null;
    Naziv:string = null;
    SvojinaID:number = null;
    Glavni:boolean = null;
    Opis: string = null;
    ZaSef: boolean = null;

    Deserialize(input:any){
        // super.Deserialize(input);
        this.ID=input.ID;
        this.KomitentID=input.KomitentID;
        this.Naziv=input.Naziv;
        this.SvojinaID=input.SvojinaID;
        this.Glavni=input.Glavni;
        this.Opis=input.Opis;
        this.ZaSef = input.ZaSef;
        return this;
    }

    Serialize(input:KomitentEmail){
        return input;
    }
}